import { cn } from '../cn.js';
import { useUiLabels } from '../labels.js';

export function Spinner({ className }: { className?: string }) {
  const labels = useUiLabels();
  return (
    <span
      role="status"
      aria-label={labels.loading}
      className={cn(
        'inline-block size-4 animate-spin rounded-full border-2 border-current border-r-transparent',
        className,
      )}
    />
  );
}
